/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DistributionChannelResponse
 */
export interface DistributionChannelResponse {
    /**
     * 
     * @type {number}
     * @memberof DistributionChannelResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DistributionChannelResponse
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DistributionChannelResponse
     */
    effectiveFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DistributionChannelResponse
     */
    effectiveTo?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DistributionChannelResponse
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DistributionChannelResponse
     */
    effective?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DistributionChannelResponse
     */
    enabled?: boolean;
}

export function DistributionChannelResponseFromJSON(json: any): DistributionChannelResponse {
    return DistributionChannelResponseFromJSONTyped(json, false);
}

export function DistributionChannelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributionChannelResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : (json['effectiveFrom'] === null ? null : new Date(json['effectiveFrom'])),
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : (json['effectiveTo'] === null ? null : new Date(json['effectiveTo'])),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function DistributionChannelResponseToJSON(value?: DistributionChannelResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'effectiveFrom': value.effectiveFrom === undefined ? undefined : (value.effectiveFrom === null ? null : value.effectiveFrom.toISOString()),
        'effectiveTo': value.effectiveTo === undefined ? undefined : (value.effectiveTo === null ? null : value.effectiveTo.toISOString()),
        'deleted': value.deleted,
        'effective': value.effective,
        'enabled': value.enabled,
    };
}


